module.exports = __webpack_public_path__ + "img/chempae-tn.0e845f09.jpg";